import React, {FC} from 'react'

import starIcon from '@/images/icons/star.svg'

import * as s from './stars.styles'

interface Props {
    numberOfStars: number
}

const Stars: FC<Props> = ({numberOfStars}) => (
    <s.Wrapper>
        {[...Array(numberOfStars)].map((star, i) => (
            <img src={starIcon} alt={`${numberOfStars} star rating`} key={i} />
        ))}
    </s.Wrapper>
)

export default Stars
